import Vue from 'vue'
import VueCookies from "vue-cookies";
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import http from "./utils/http";

Vue.use(VueCookies)

Vue.config.productionTip = false
Vue.prototype.$http = http;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
